export default "__VITE_ASSET__6i$8DTaU__"